module.exports = __webpack_public_path__ + "img/part9-8.4f9e1963.png";